// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s8-5";
export var filledCircle = "_s8-4";
export var historyEntry = "_s8-3";
export var messageSideLeft = "_s8-1";
export var messageSideRight = "_s8-2";
export var orderTrackingCarouselWrapper = "_s8-6";
export var orderTrackingInfoContainer = "_s8-0";